var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Col, Row } from '../../../../../components/Grid';
import { CloseOutline } from '../../../../../components/Icon';
import { Tooltip } from '../../../../../components/Tooltip';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, ActionButton, Title, ArrowRight, Popover, PopoverContent, PopoverContentTitle, PopoverContentText } from './styled';
var reminders = [
    {
        title: 'Сейчас нет времени?',
        subtitle: 'Пройдите опрос, когда освободитесь — \nэто займёт всего 2 минуты 😉',
    },
    {
        title: 'Хотите улучшить сервис? 😀',
        subtitle: 'Пройдите опрос — это займёт \nвсего 2 минуты',
        delayValue: 4,
        delayUnit: 'hours',
    }
];
var sfbStorageKey = 'sfb-poll-reminder';
export var SFB = function (_a) {
    var collapsed = _a.collapsed;
    var _b = __read(useState(), 2), canShowModal = _b[0], setCanShowModal = _b[1];
    var _c = __read(useState(-1), 2), currentReminder = _c[0], setCurrentReminder = _c[1];
    var _d = __read(useState(false), 2), reminderVisible = _d[0], setReminderVisible = _d[1];
    var hideReminder = useCallback(function () {
        if (!reminderVisible)
            return;
        setReminderVisible(false);
        localStorage.setItem(sfbStorageKey + "-" + currentReminder, new Date().toISOString());
    }, [reminderVisible, currentReminder]);
    var handleModalShow = useCallback(function () {
        var _a, _b;
        hideReminder();
        (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.sfb) === null || _b === void 0 ? void 0 : _b.showModal();
    }, [hideReminder]);
    useEffect(function () {
        var intervalHash = setInterval(function () {
            var _a, _b;
            setCanShowModal((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.sfb) === null || _b === void 0 ? void 0 : _b.canShowModal);
        }, 500);
        return function () {
            clearInterval(intervalHash);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var showReminder = useCallback(function (idx) {
        if (idx === void 0) { idx = 0; }
        if (!canShowModal || !reminders[idx])
            return;
        var value = localStorage.getItem(sfbStorageKey + "-" + idx);
        var dateTime = value ? moment(value) : null;
        var alreadyShownToday = dateTime === null || dateTime === void 0 ? void 0 : dateTime.isSame(new Date(), 'day');
        if (alreadyShownToday) {
            return showReminder(idx + 1);
        }
        var prevReminderValue = localStorage.getItem(sfbStorageKey + "-" + (idx - 1));
        if (prevReminderValue) {
            var delayValue = reminders[idx].delayValue || 0;
            var delayUnit = reminders[idx].delayUnit || 'seconds';
            var isDelayed = moment().diff(prevReminderValue, delayUnit) < delayValue;
            if (isDelayed)
                return;
        }
        setCurrentReminder(idx);
        if (!reminderVisible)
            setReminderVisible(true);
    }, [canShowModal, reminderVisible]);
    useEffect(function () {
        showReminder();
    }, [canShowModal, showReminder]);
    var popoverContent = useMemo(function () {
        var _a, _b;
        return (React.createElement(PopoverContent, null,
            React.createElement(PopoverContentTitle, null, (_a = reminders[currentReminder]) === null || _a === void 0 ? void 0 :
                _a.title,
                React.createElement(CloseOutline, { onClick: hideReminder })),
            React.createElement(PopoverContentText, null, (_b = reminders[currentReminder]) === null || _b === void 0 ? void 0 : _b.subtitle)));
    }, [currentReminder, hideReminder]);
    if (!canShowModal)
        return null;
    return (React.createElement(Popover, { placement: "rightBottom", visible: reminderVisible, content: popoverContent, trigger: [] },
        React.createElement(Tooltip, { trigger: collapsed ? ['hover'] : [], placement: "right", overlay: "\u041F\u0440\u043E\u0439\u0442\u0438 \u043E\u043F\u0440\u043E\u0441" },
            React.createElement(Button, { onClick: handleModalShow, "$collapsed": collapsed },
                !collapsed && (React.createElement(Title, null, "\u041E\u0446\u0435\u043D\u0438\u0442\u0435 \u043D\u0430\u0448 \u043F\u0440\u043E\u0434\u0443\u043A\u0442")),
                React.createElement(Row, { wrap: false },
                    !collapsed && (React.createElement(Col, { flex: 1 },
                        React.createElement(ActionButton, { id: "sfb_action_button" }, "\u041F\u0440\u043E\u0439\u0442\u0438 \u043E\u043F\u0440\u043E\u0441"))),
                    React.createElement(Col, { id: "sfb_arrow_right" },
                        React.createElement(ArrowRight, null)))))));
};
//# sourceMappingURL=SFB.js.map